import { render, staticRenderFns } from "./QuestionDesc.vue?vue&type=template&id=096fa0e0&scoped=true"
import script from "./QuestionDesc.vue?vue&type=script&lang=js"
export * from "./QuestionDesc.vue?vue&type=script&lang=js"
import style0 from "./QuestionDesc.vue?vue&type=style&index=0&id=096fa0e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096fa0e0",
  null
  
)

export default component.exports